import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    hasTyped: boolean;
};

export function LoadingState(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <Body size='large' color='light'>
                {props.hasTyped ? 'Searching…' : 'Loading…'}
            </Body>
            <div className='flex justify-center'>
                <LoadingIcon fill={colors.greyLt} size={40} />
            </div>
        </StackLegacy>
    );
}
